import defaultOIDCConfig from './default-oidc-config';
import getAppConfig from './get-app-config';
import { restoreOriginalUri } from './restore-original-uri';
import transformAuthState from './transform-auth-state';

interface OIDCConfig {
  baseUrl: string;
  issuerPath: string;
  redirectUri: string;
  issuer?: string;
  postLogoutRedirectUri?: string;
  redirectAfterLogin?: string;
  restoreOriginalUri?: unknown;
  transformAuthState?: unknown;
  [key: string]: unknown;
}

const appConfig = getAppConfig();
const { login, oktaOIDC, server } = appConfig;

// Merge the default OIDC configuration from platform with app‑specific OIDC config
const config: OIDCConfig = {
  ...defaultOIDCConfig,
  ...oktaOIDC,
  restoreOriginalUri,
  transformAuthState
};

// Derived properties (same runtime behavior as JS)
config.issuer = `${config.baseUrl}${config.issuerPath}`;
config.redirectUri = `${server.host}${server.path}${config.redirectUri}`;
config.postLogoutRedirectUri = `${server.host}${server.path}${login.redirectAfterLogout}`;
config.redirectAfterLogin = login.redirectAfterLogin;

export default config;